<!-- <div class="arrow-steps">
    <div style="overflow-x: auto; width: 100%;">
        <ng-container *ngFor="let stage of estimateStages1; let i = index;">
            <div *ngIf="stage?.id != null" class="step"
            [ngClass]="{
                'current': (estimatesDetails.estimateStageId == stage.id) ||
                    ([5, 6].includes(estimatesDetails.estimateStageId) && stage.id === -1),
                'handPointer': !editPermission
            }"
            [ngStyle]="{
                width: estimateStages1.length > 1 ?
                (100 / estimateStages1.length) + '%' : '10%', maxWidth: 100 / estimateStages1.length > 1
                ? (100 / estimateStages1.length) + '%' : '15%'
            }"
            [class.inactive]="estimatesDetails?.statusId !== 1">
            <span>
                {{ stage.name }}
            </span>
        </div>
        </ng-container>
    </div>
</div>
<div class="arrow-steps">
    <div style="overflow-x: auto; width: 100%;">
        <ng-container *ngFor="let stage of estimateStages2; let i = index;">
            <div *ngIf="stage?.id != null" class="step"
            [ngClass]="{
                'current': (estimatesDetails.estimateStageId == stage.id) ||
                    ([5, 6].includes(estimatesDetails.estimateStageId) && stage.id === -1),
                'handPointer': !editPermission
            }"
            [ngStyle]="{
                width: estimateStages2.length > 1 ?
                (100 / estimateStages2.length) + '%' : '10%', maxWidth: 100 / estimateStages2.length > 1
                ? (100 / estimateStages2.length) + '%' : '15%'
            }"
            [class.inactive]="estimatesDetails?.statusId !== 1">
            <span>
                {{ stage.name }}
            </span>
        </div>
        </ng-container>
    </div>
</div>
<div class="arrow-steps">
    <div style="overflow-x: auto; width: 100%;">
        <ng-container *ngFor="let stage of estimateStages3; let i = index;">
            <div *ngIf="stage?.id != null" class="step"
            [ngClass]="{
                'current': (estimatesDetails.estimateStageId == stage.id) ||
                    ([5, 6].includes(estimatesDetails.estimateStageId) && stage.id === -1),
                'handPointer': !editPermission
            }"
            [ngStyle]="{
                width: estimateStages3.length > 1 ?
                (100 / estimateStages3.length) + '%' : '10%', maxWidth: 100 / estimateStages3.length > 1
                ? (100 / estimateStages3.length) + '%' : '15%'
            }"
            [class.inactive]="estimatesDetails?.statusId !== 1">
            <span>
                {{ stage.name }}
            </span>
        </div>
        </ng-container>
    </div>
</div>
<div class="arrow-steps">
    <div style="overflow-x: auto; width: 100%;">
        <ng-container *ngFor="let stage of estimateStages4; let i = index;">
            <div *ngIf="stage?.id != null" class="step"
            [ngClass]="{
                'current': (estimatesDetails.estimateStageId == stage.id) ||
                    ([5, 6].includes(estimatesDetails.estimateStageId) && stage.id === -1),
                'handPointer': !editPermission
            }"
            [ngStyle]="{
                width: estimateStages4.length > 1 ?
                (100 / estimateStages4.length) + '%' : '10%', maxWidth: 100 / estimateStages4.length > 1
                ? (100 / estimateStages4.length) + '%' : '15%'
            }"
            [class.inactive]="estimatesDetails?.statusId !== 1">
            <span>
                {{ stage.name }}
            </span>
        </div>
        </ng-container>
    </div>
</div>
<div class="arrow-steps">
    <div style="overflow-x: auto; width: 100%;">
        <ng-container *ngFor="let stage of estimateStages5; let i = index;">
            <div *ngIf="stage?.id != null" class="step"
            [ngClass]="{
                'current': (estimatesDetails.estimateStageId == stage.id) ||
                    ([5, 6].includes(estimatesDetails.estimateStageId) && stage.id === -1),
                'handPointer': !editPermission
            }"
            [ngStyle]="{
                width: estimateStages5.length > 1 ?
                (100 / estimateStages5.length) + '%' : '10%', maxWidth: 100 / estimateStages5.length > 1
                ? (100 / estimateStages5.length) + '%' : '15%'
            }"
            [class.inactive]="estimatesDetails?.statusId !== 1">
            <span>
                {{ stage.name }}
            </span>
        </div>
        </ng-container>
    </div>
</div>
<div class="arrow-steps">
    <div style="overflow-x: auto; width: 100%;">
        <ng-container *ngFor="let stage of estimateStages6; let i = index;">
            <div *ngIf="stage?.id != null" class="step"
            [ngClass]="{
                'current': (estimatesDetails.estimateStageId == stage.id) ||
                    ([5, 6].includes(estimatesDetails.estimateStageId) && stage.id === -1),
                'handPointer': !editPermission
            }"
            [ngStyle]="{
                width: estimateStages6.length > 1 ?
                (100 / estimateStages6.length) + '%' : '10%', maxWidth: 100 / estimateStages6.length > 1
                ? (100 / estimateStages6.length) + '%' : '15%'
            }"
            [class.inactive]="estimatesDetails?.statusId !== 1">
            <span>
                {{ stage.name }}
            </span>
        </div>
        </ng-container>
    </div>
</div>
<div class="arrow-steps">
    <div style="overflow-x: auto; width: 100%;">
        <ng-container *ngFor="let stage of estimateStages7; let i = index;">
            <div *ngIf="stage?.id != null" class="step"
            [ngClass]="{
                'current': (estimatesDetails.estimateStageId == stage.id) ||
                    ([5, 6].includes(estimatesDetails.estimateStageId) && stage.id === -1),
                'handPointer': !editPermission
            }"
            [ngStyle]="{
                width: estimateStages7.length > 1 ?
                (100 / estimateStages7.length) + '%' : '10%', maxWidth: 100 / estimateStages7.length > 1
                ? (100 / estimateStages7.length) + '%' : '15%'
            }"
            [class.inactive]="estimatesDetails?.statusId !== 1">
            <span>
                {{ stage.name }}
            </span>
        </div>
        </ng-container>
    </div>
</div> -->

<p-tabView (onChange)="onTabChange($event)" [ngClass]="{'gltab': visibleFromModule != 'Finance'}">
    <p-tabPanel header="Overview">
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12 p-md-6">
                <div class="p-fluid">
                    <div class="card" style="min-height: 135px">
                        <h6 class="p-mb-0">Billing</h6>
                        <p class="p-mb-0">
                            <span *ngIf="templates?.labels_billaddress[5]?.isChecked">
                                {{ estimateDetails?.account?.sequenceNumber ? estimateDetails?.account?.sequenceNumber + " - " : "" }}
                            </span>
                            <span class="p-mb-0 acc-name-popup-link" (click)="onAccountViewClick(estimateDetails)" *ngIf="templates?.labels_billaddress[0]?.isChecked">
                                {{ estimateDetails?.account?.businessName }}
                            </span>
                        </p>
                        <ng-container *ngIf="billingAddress">
                            <!-- Street -->
                            <p class="p-mb-0" *ngIf="templates?.labels_billaddress[1]?.isChecked">
                                {{ billingAddress?.address?.streetAddress1 }}
                                <span *ngIf="billingAddress?.address && billingAddress?.address?.streetAddress1 && billingAddress?.address?.streetAddress1 != '' && billingAddress?.address?.streetAddress2 && billingAddress?.address?.streetAddress2 != ''">,</span>
                                {{ billingAddress?.address?.streetAddress2 }}
                            </p>
                            <!--Address-->
                            <p class="p-mb-0" *ngIf="templates?.labels_billaddress[2]?.isChecked">
                                {{ billingAddress?.address?.city?.name }}
                                <span *ngIf="billingAddress?.address && billingAddress?.address?.city && billingAddress?.address?.city?.name && billingAddress?.address?.city?.name != '' && billingAddress?.address?.city?.state && billingAddress?.address?.city?.state?.name != ''">,</span>
                                {{ billingAddress?.address?.city?.state?.name }} <span *ngIf="billingAddress?.address && billingAddress?.address?.city && billingAddress?.address?.city?.state && billingAddress?.address?.city?.state?.name && billingAddress?.address?.city?.state?.name != '' && billingAddress?.address?.city?.state?.country && billingAddress?.address?.city?.state?.country?.name != ''">,</span>
                                {{ billingAddress?.address?.city?.state?.country?.name }}
                                <span *ngIf="billingAddress?.address && billingAddress?.address?.city && billingAddress?.address?.city?.state && billingAddress?.address?.city?.state?.country && billingAddress?.address?.city?.state?.country?.name && billingAddress?.address?.city?.state?.country?.name != '' && billingAddress?.address?.zipCode && billingAddress?.address?.zipCode != ''">,</span>
                                {{ billingAddress?.address?.zipCode }}
                            </p>
                            <!--billing contact-->
                            <p class="p-mb-0" *ngIf="templates?.labels_billaddress[3]?.isChecked"> {{ billingAddressContact?.firstName }} {{ billingAddressContact?.lastName ? " " : "" }} {{ billingAddressContact?.lastName }} </p>
                            <p class="p-mb-0" *ngIf="templates?.labels_billaddress[4]?.isChecked">
                                {{ billingAddressContact && billingAddressContact?.contactPhones && billingAddressContact?.contactPhones[0]?.phone && billingAddressContact?.contactPhones[0]?.phone?.number ? billingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                            </p>
                        </ng-container>
                        <!-- custom -->
                        <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields.billing_address_item"> </app-custom-attribute-overview>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-6">
                <div class="p-fluid">
                    <div class="card" style="min-height: 135px">
                        <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%">
                            <div style="display: flex; flex-direction: column; align-items: flex-start; width: 70%">
                                <p class="p-mb-0" style="margin-top: 13px" *ngIf="templates?.labels_misc[0]?.isChecked">
                                    {{ templates?.labels_misc[0]?.labelname }}:
                                    <span>{{ estimateDetails?.estimateDate | date: "MM/dd/yyyy" }}</span>
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc[1]?.isChecked">
                                    {{ templates?.labels_misc[1]?.labelname }}:
                                    <span>{{ estimateDetails?.expiryDate | date: "MM/dd/yyyy" }}</span>
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc[2]?.isChecked">
                                    {{ templates?.labels_misc[2]?.labelname }}:
                                    <span>{{ estimateDetails?.number }}</span>
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc[3]?.isChecked">
                                    {{ templates?.labels_misc[3]?.labelname }}:
                                    <span>{{ estimateDetails?.estimateStatus }}</span>
                                    <!-- <span class="hyper-link p-ml-3" (click)="changeStatus()">Change status</span> -->
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc[4]?.isChecked"> {{ templates?.labels_misc[6]?.labelname }}: {{ estimateDetails?.warehouse?.locationId }} </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc[4]?.isChecked">
                                    {{ templates?.labels_misc[4]?.labelname }}:
                                    <span>{{ estimateDetails?.createdByUser }}</span>
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc[5]?.isChecked">
                                    {{ templates?.labels_misc[5]?.labelname }}:
                                    <span>{{ estimateDetails?.referenceNumber }}</span>
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc[7]?.isChecked && estimateDetails?.salesOrderId != 0">
                                    {{ templates?.labels_misc[7]?.labelname }}:
                                    <span class="p-mb-0 acc-name-popup-link" (click)="navigateToSalesOrder(estimateDetails)">{{ estimateDetails?.salesOrderNo }}</span>
                                    <span class="p-ml-1" *ngIf="estimateDetails?.salesOrderDate">
                                        {{ estimateDetails?.salesOrderDate | date: "MM/dd/yyyy" }}
                                    </span>
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc[8]?.isChecked && estimateDetails?.invoiceId != 0">
                                    {{ templates?.labels_misc[8]?.labelname }}:
                                    <span class="p-mb-0 acc-name-popup-link" (click)="navigateToInvoice(estimateDetails)">{{ estimateDetails?.invoiceNo }}</span>
                                    <span class="p-ml-1" *ngIf="estimateDetails?.invoiceDate">
                                        {{ estimateDetails?.invoiceDate | date: "MM/dd/yyyy" }}
                                    </span>
                                </p>
                                <p class="p-mb-0" *ngIf="templates?.labels_misc[9]?.isChecked && estimateDetails?.opportunityId != 0">
                                    {{ templates?.labels_misc[9]?.labelname }}:
                                    <span class="p-mb-0 acc-name-popup-link" (click)="navigateToOpportunity(estimateDetails)">{{ estimateDetails?.opportunityNo }}</span>
                                </p>
                                <!-- Currency: -->
                                <p class="p-mb-0" *ngIf="templates?.labels_misc[10]?.isChecked && (baseCurrency?.currencyId !== estimateDetails?.account?.currencyId)">
                                    {{ templates?.labels_misc[10]?.labelname }}: 
                                    <span>1 {{ baseCurrency?.code }} = {{ estimateDetails?.exchangeRate }} {{ estimateDetails?.account?.currencyUnit?.code }}</span>
                                </p>
                                <!-- custom -->
                                <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields?.misc_item"> </app-custom-attribute-overview>
                            </div>
                            <div style="display: flex; flex-direction: column; align-items: flex-end; width: 30%">
                                <span style="color: #ce1800" *ngIf="showEstimateVoidMsg" pTooltip="on {{ voidDate }} <br/>by {{ app.user.userName }}" tooltipPosition="top" [escape]="false"> Voided </span>
                                @if (estimateDetails?.approvalStatusId && estimateDetails?.approvalStatusId > 0) {
                                    <p-button label="{{ estimateDetails?.approvalStatus ? estimateDetails?.approvalStatus : '' }}" [text]="true" [raised]="true" severity="danger" class="large-font" (onClick)="showApprovalDetails(estimateDetails)" />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid">
            <div class="p-col" *ngIf="templates?.labels_section[0]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section[0]?.labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ estimateDetails?.paymentTerm?.name }}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="templates?.labels_section[1]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section[1]?.labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ estimateDetails?.paymentMethod?.name }}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="templates?.labels_section[2]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section[2]?.labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ estimateDetails?.shippingTerm?.name }}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="templates?.labels_section[3]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section[3]?.labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ estimateDetails?.shippingMethod?.name }}
                    </p>
                </div>
            </div>
            <div class="p-col" *ngIf="templates?.labels_section[4]?.isChecked">
                <div class="card">
                    <h6 class="p-mb-0">
                        {{ templates?.labels_section[4]?.labelname }}
                    </h6>
                    <p class="p-mb-0">
                        {{ estimateDetails?.salesRep }}
                    </p>
                </div>
            </div>
        
            <!-- custom section -->
            <app-custom-attribute-overview [fieldType]="fieldTypes.SECTION" [customFieldData]="customFields.section_item"> </app-custom-attribute-overview>
        </div>
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12">
                <p-table [value]="purchaseList" styleClass="p-datatable-gridlines p-datatable-striped" dataKey="id">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 3rem"></th>
                            <th *ngIf="templates?.labels_table[0]?.isChecked">
                                {{ templates?.labels_table[0]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[13]?.isChecked">
                                {{ templates?.labels_table[13]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[1]?.isChecked" style="width: 200px">
                                {{ templates?.labels_table[1]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[8]?.isChecked">
                                {{ templates?.labels_table[8]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[2]?.isChecked">
                                {{ templates?.labels_table[2]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[3]?.isChecked">
                                {{ templates?.labels_table[3]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[11]?.isChecked">
                                {{ templates?.labels_table[11]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[12]?.isChecked">
                                {{ templates?.labels_table[12]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[4]?.isChecked">
                                {{ templates?.labels_table[4]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[9]?.isChecked">
                                {{ templates?.labels_table[9]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[6]?.isChecked">
                                {{ templates?.labels_table[6]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[5]?.isChecked">
                                {{ templates?.labels_table[5]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[10]?.isChecked">
                                {{ templates?.labels_table[10]?.labelname }}
                            </th>
                            <th *ngIf="templates?.labels_table[7]?.isChecked">
                                {{ templates?.labels_table[7]?.labelname }}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-index="rowIndex" let-expanded="expanded">
                        <tr [ngClass]="{ copiedProductRow: product?.isCopied }">
                            <td>
                                <button type="button" pButton pRipple [pRowToggler]="product" class="p-button-text p-button-rounded p-button-plain" *ngIf="product?.estimateBundleDetail?.length > 0" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" style="width: 1.25rem; height: 1.25rem"></button>
                            </td>
                            <td *ngIf="templates?.labels_table[0]?.isChecked">
                                {{ product.itemNo ? product.itemNo : null }}
                            </td>
                            <td *ngIf="templates?.labels_table[13]?.isChecked">
                                {{ product.hsnsac ? product.hsnsac : null }}
                            </td>
                            <td *ngIf="templates?.labels_table[1]?.isChecked">
                                <p-cellEditor style="word-break: break-word; white-space: pre-line">
                                    <ng-template pTemplate="output">
                                        {{ product.description ? (product.description | shorten: 55) : null }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                {{product.availableQty ? (product.availableQty  | customNumberFormat: qtyFractionDigits) : null }}
                            </td>
                            <td *ngIf="templates?.labels_table[2]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.qty ? (product.qty | customNumberFormat: qtyFractionDigits) : null }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[3]?.isChecked">
                                {{ product.uom ? product.uom : null }}
                            </td>
                            <td *ngIf="templates?.labels_table[11]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.costPrice | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[12]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.totalCostPrice | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[4]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.rate | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[9]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.subTotal | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[6]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.discountAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        <span *ngIf="product?.discountPercentage && product?.discountPercentage > 0"> ({{ product?.discountPercentage }}%) </span>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[5]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.taxAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[10]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output" *ngIf="product.typeId != 4">
                                        {{ product.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }} {{ product?.additionalFeesType == "Percentage" && product?.additionalRate && product?.additionalRate > 0 ? "(" + product?.additionalRate + ")%" : "" }}
        
                                        <!-- <span *ngIf="product?.additionalFeesType == 'Amount' && product?.additionalAmount && product?.additionalAmount > 0">
                                             {{ product.additionalAmount | multicurrency: (savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate): (estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol): fractionDigits }} {{ product?.additionalRate && product?.additionalRate > 0 ? '(' + product?.additionalRate + ')%' : '' }}
                                        </span>
                                        <span *ngIf="product?.additionalFeesType == 'Percentage' && product?.additionalRate && product?.additionalRate > 0"> 
                                            {{ product.additionalAmount | multicurrency: (savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate): (estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol): fractionDigits }}({{ product?.additionalRate }}%) 
                                        </span> -->
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="templates?.labels_table[7]?.isChecked">
                                <p-cellEditor>
                                    <ng-template pTemplate="output">
                                        {{ product.amount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-product>
                        <!-- bundle items -->
                        <ng-container *ngFor="let bundleProduct of product?.estimateBundleDetail">
                            <tr class="bundleRow">
                                <td class="action">
                                    <button type="button" pButton pRipple *ngIf="bundleProduct.estimateBundleDetail?.length > 0" (click)="bundleProduct.show = !bundleProduct.show" class="p-button-text p-button-rounded p-button-plain p-ml-2" [icon]="bundleProduct.show ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" style="width: 1.25rem; height: 1.25rem"> </button>
                                </td>
                                <td *ngIf="templates?.labels_table[0]?.isChecked" style="padding-left: 1.5rem !important">
                                    {{ bundleProduct.itemNo ? bundleProduct.itemNo : null }}
                                </td>
                                <td *ngIf="templates?.labels_table[13]?.isChecked" style="padding-left: 1.5rem !important">
                                    {{ bundleProduct.hsnsac ? bundleProduct.hsnsac : null }}
                                </td>
                                <td *ngIf="templates?.labels_table[1]?.isChecked">
                                    <p-cellEditor style="word-break: break-word; white-space: pre-line">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct?.description ? (bundleProduct?.description | shorten: 55) : null }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    {{bundleProduct.availableQty ? (bundleProduct.availableQty  | customNumberFormat: qtyFractionDigits) : null }}
                                </td>
                                <td *ngIf="templates?.labels_table[2]?.isChecked">
                                    <p-cellEditor>
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.qty ? (bundleProduct.qty | customNumberFormat: qtyFractionDigits) : null }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[3]?.isChecked">
                                    <p-cellEditor>
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.uom ? bundleProduct.uom : null }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[11]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.costPrice | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[12]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.totalCostPrice | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[4]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.rate | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[9]?.isChecked">
                                    <span *ngIf="product.typeId != 6">
                                        {{ bundleProduct.subTotal | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                    </span>
                                </td>
                                <td *ngIf="templates?.labels_table[6]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.discountAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                            <span *ngIf="bundleProduct?.discountPercentage && bundleProduct?.discountPercentage > 0"> ({{ bundleProduct?.discountPercentage }}%) </span>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[5]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.taxAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[10]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output"> {{ bundleProduct.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }} {{ bundleProduct?.additionalFeesType == "Percentage" && bundleProduct?.additionalRate && bundleProduct?.additionalRate > 0 ? "(" + bundleProduct?.additionalRate + ")%" : "" }} </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="templates?.labels_table[7]?.isChecked">
                                    <p-cellEditor *ngIf="product.typeId != 6">
                                        <ng-template pTemplate="output">
                                            {{ bundleProduct.amount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                            </tr>
                            <!-- kit under kit -->
                            <ng-container *ngIf="bundleProduct.show">
                                <tr *ngFor="let kp of bundleProduct.estimateBundleDetail" class="bundleRowSub">
                                    <td></td>
                                    <td *ngIf="templates?.labels_table[0]?.isChecked" style="padding-left: 2rem !important">
                                        {{ kp.itemNo ? kp.itemNo : null }}
                                    </td>
                                    <td *ngIf="templates?.labels_table[13]?.isChecked" style="padding-left: 2rem !important">
                                        {{ kp.hsnsac ? kp.hsnsac : null }}
                                    </td>
                                    <td *ngIf="templates?.labels_table[1]?.isChecked">
                                        {{ kp?.description ? (kp?.description | shorten: 55) : null }}
                                    </td>
                                    <td>
                                    {{kp.availableQty ? (kp.availableQty  | customNumberFormat: qtyFractionDigits) : null }}
                                    </td>
                                    <td *ngIf="templates?.labels_table[2]?.isChecked">
                                        <p-cellEditor>
                                            <ng-template pTemplate="output">
                                                {{ kp.qty ? (kp.qty | customNumberFormat: qtyFractionDigits) : null }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td *ngIf="templates?.labels_table[3]?.isChecked">
                                        {{ kp.uom ? kp.uom : null }}
                                    </td>
                                    <td *ngIf="templates?.labels_table[11]?.isChecked"> </td>
                                    <td *ngIf="templates?.labels_table[12]?.isChecked"> </td>
                                    <td *ngIf="templates?.labels_table[4]?.isChecked"> </td>
                                    <td *ngIf="templates?.labels_table[9]?.isChecked"> </td>
                                    <td *ngIf="templates?.labels_table[5]?.isChecked"> </td>
                                    <td *ngIf="templates?.labels_table[6]?.isChecked"> </td>
                                    <td *ngIf="templates?.labels_table[7]?.isChecked"> </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <tr>
                            <td></td>
                            <td class="p-text-left">{{ templates?.labels_footer[0]?.labelname }}</td>
                            <td class="p-text-left"></td>
                            <td></td>
                            <td *ngIf="templates?.labels_table[13]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[2]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[3]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[11]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[12]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[4]?.isChecked"></td>
                            <td *ngIf="templates?.labels_table[9]?.isChecked">{{ estimateDetails?.totalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="templates?.labels_table[6]?.isChecked">{{ estimateDetails?.discountAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="templates?.labels_table[5]?.isChecked">{{ estimateDetails?.taxAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="templates?.labels_table[10]?.isChecked">{{ productsTotalAdditionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                            <td *ngIf="templates?.labels_table[7]?.isChecked">{{ totalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}</td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[0]?.isChecked && !templates?.labels_table[9]?.isChecked">
                            <td></td>
                            <td colspan="2" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[0]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[0]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer[0]?.labelname }}
                            </td>
                            <td colspan="1">
                                {{ estimateDetails?.totalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[1]?.isChecked && !templates?.labels_table[6]?.isChecked">
                            <td></td>
                            <td colspan="2" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[1]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[1]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer[1]?.labelname }}
                            </td>
                            <td colspan="1">
                                {{ estimateDetails?.discountAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[2]?.isChecked && !templates?.labels_table[5]?.isChecked">
                            <td></td>
                            <td colspan="2" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[2]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[2]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">{{ templates?.labels_footer[2]?.labelname }}</td>
                            <td colspan="1">
                                {{ estimateDetails?.taxAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[6]?.isChecked">
                            <td></td>
                            <td colspan="2" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[2]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[2]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">{{ templates?.labels_footer[6]?.labelname }}</td>
                            <td colspan="1">
                                {{ estimateDetails?.additionalAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[5]?.isChecked">
                            <td></td>
                            <td colspan="2" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[5]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[5]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer[5]?.labelname }}
                            </td>
                            <td colspan="1">
                                {{ estimateDetails?.additionalDiscount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
        
                        <tr *ngIf="templates?.labels_footer[3]?.isChecked">
                            <td></td>
                            <td colspan="2" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[3]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[3]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer[3]?.labelname }}
                            </td>
                            <td colspan="1">
                                {{ estimateDetails?.shippingChargeAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                        <tr *ngIf="templates?.labels_footer[4]?.isChecked">
                            <td></td>
                            <td colspan="2" class="p-text-left">
                                <!-- Custom -->
                                <app-custom-attribute-overview *ngIf="customFields?.footer_item && customFields.footer_item[4]" [fieldType]="fieldTypes.FOOTER" [customFieldData]="customFields.footer_item[4]"> </app-custom-attribute-overview>
                            </td>
                            <td [attr.colspan]="cols - 3" class="p-text-right">
                                {{ templates?.labels_footer[4]?.labelname }}
                            </td>
                            <td colspan="1">
                                {{ estimateDetails?.netAmount | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : estimatesDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits }}
                            </td>
                        </tr>
                    </ng-template>
                    `
                </p-table>
            </div>
        </div>
        
        <div *ngIf="showTaxBasedSplitView">
            <app-products-tax-split-view [products]="purchaseList" [isStateMatched]="isStateMatched" [savedCurrencyExchangeRate]="savedCurrencyExchangeRate" 
                [savedCurrencyUnit]="savedCurrencyUnit" [channel]="soChannel.ESTIMATES">
            </app-products-tax-split-view>
        </div>
        
        <div class="p-col-12 p-md-12">
            <div class="p-fluid">
                <div class="card" style="min-height: 100px">
                    <p class="p-mb-0" *ngIf="templates?.labels_message[0]?.isChecked">
                        <b>{{ templates?.labels_message[0]?.labelname }}:</b>
                        <span>{{ estimateDetails?.estimateAudits && estimateDetails?.estimateAudits.length > 0 ? estimateDetails?.estimateAudits[estimateDetails?.estimateAudits.length - 1].note.comment : "" }}</span>
                    </p>
                    <p class="p-mb-0" *ngIf="templates?.labels_message[1]?.isChecked">
                        <span>
                            <b style="display: inline">{{ templates?.labels_message[1]?.labelname }}:</b>
                            <span style="display: inline; white-space: normal; max-width: 100%" *ngIf="estimateDetails?.estimateNotes && estimateDetails?.estimateNotes.length > 0">
                                <span [innerHTML]="getSanitizedHtml(estimateDetails?.estimateNotes[estimateDetails?.estimateNotes.length - 1]?.note?.comment)"></span>
                            </span>
                        </span>
                    </p>
        
                    <!-- custom -->
                    <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields.message_item"> </app-custom-attribute-overview>
                </div>
            </div>
        </div>
        
        <div class="p-col-12 p-md-12" *ngIf="customFields?.other1_item && customFields?.other1_item.length > 0">
            <div class="p-fluid">
                <div class="card" style="min-height: 135px">
                    <h6 class="p-mb-0">{{ getFilteredSectionsByType("labels_estimate_other1") }}</h6>
                    <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields.other1_item"> </app-custom-attribute-overview>
                </div>
            </div>
        </div>
        
        <div class="p-col-12 p-md-12" *ngIf="customFields?.other2_item && customFields?.other2_item?.length > 0">
            <div class="p-fluid">
                <div class="card" style="min-height: 135px">
                    <h6 class="p-mb-0">{{ getFilteredSectionsByType("labels_estimate_other2") }}</h6>
                    <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields.other2_item"> </app-custom-attribute-overview>
                </div>
            </div>
        </div>
        
        <div class="p-col-12 p-md-12" *ngIf="customFields?.other3_item && customFields?.other3_item?.length > 0">
            <div class="p-fluid">
                <div class="card" style="min-height: 135px">
                    <h6 class="p-mb-0">{{ getFilteredSectionsByType("labels_estimate_other3") }}</h6>
                    <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD" [customFieldData]="customFields.other3_item"> </app-custom-attribute-overview>
                </div>
            </div>
        </div>
        
        <!-- Inventory Overview -->
        <app-inventory-module-overview-dialogs *ngIf="displayInventoryOverview" [displayOverview]="displayInventoryOverview" [overviewRefId]="inventoryOverviewRefId" [overviewRefNumber]="inventoryOverviewRefNumber" [overviewModule]="inventoryOverviewModule" (onCancel)="closeViewPopup()"> </app-inventory-module-overview-dialogs>
        
        <!-- Approval Details -->
        <app-approval-details *ngIf="displayViewApproval" [displayViewApproval]="displayViewApproval" [approvalTypeInfo]="approvalTypeInfo" (approvalStatusChange)="handleApprovalStatus($event.isUpdate)" (cancelClick)="displayViewApproval = false"> </app-approval-details>
        
        <p-dialog header="Status Change" [(visible)]="displayChangeStatus" [style]="{ width: '60vw' }">
            <div class="card">
                <p>when draft</p>
                <div class="p-grid">
                    <div class="p-col" *ngFor="let s of statusOption1">
                        <p-card [style]="{ width: '100%' }" styleClass="hover-box">
                            <h6 class="p-mb-0">{{ s.name }}</h6>
                        </p-card>
                    </div>
                </div>
                <p>when review required</p>
                <div class="p-grid">
                    <div class="p-col" *ngFor="let s of statusOption2">
                        <p-card [style]="{ width: '100%' }" styleClass="hover-box">
                            <h6 class="p-mb-0">{{ s.name }}</h6>
                        </p-card>
                    </div>
                </div>
                <p>when approved</p>
                <div class="p-grid">
                    <div class="p-col" *ngFor="let s of statusOption3">
                        <p-card [style]="{ width: '100%' }" styleClass="hover-box">
                            <h6 class="p-mb-0">{{ s.name }}</h6>
                        </p-card>
                    </div>
                </div>
                <p>when presented</p>
                <div class="p-grid">
                    <div class="p-col" *ngFor="let s of statusOption4">
                        <p-card [style]="{ width: '100%' }" styleClass="hover-box">
                            <h6 class="p-mb-0">{{ s.name }}</h6>
                        </p-card>
                    </div>
                </div>
                <p>when accepted</p>
                <div class="p-grid">
                    <div class="p-col" *ngFor="let s of statusOption5">
                        <p-card [style]="{ width: '100%' }" styleClass="hover-box">
                            <h6 class="p-mb-0">{{ s.name }}</h6>
                        </p-card>
                    </div>
                </div>
            </div>
            <ng-template pTemplate="footer">
                <button type="button" pButton (click)="displayChangeStatus = false" label="Cancel" class="p-button-secondary"></button>
                <button type="button" pButton label="Save"></button>
            </ng-template>
        </p-dialog>
        
    </p-tabPanel>
    <p-tabPanel header="Impacts on G/L">
        <app-inventory-impacts-gl [selectedId]="estimateId" [objectTypeId]="transactionTypeIds.Estimate" [callApi]="glApiCall"></app-inventory-impacts-gl>
    </p-tabPanel>
</p-tabView>
